import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../components/Layout/Layout';

export const frontmatter = {
  title: 'Presseschau',
  menu: 3,
};

export default () => {
  return (
    <Layout>
      <Helmet>
        <title>{frontmatter.title}</title>
      </Helmet>
      <article>
        <header>
          <h1>Vom Blinddarm bis zum E-Rezept</h1>
          <p>
            <small>
              <i>
                Dieser Artikel von Günter Göge erschien ursprünglich im
                Klosterglöckchen.
              </i>
            </small>
          </p>
        </header>
        <p>
          Als sich die Apothekerin Pia Ueberson vor drei Jahren selbständig
          machte, stieß das auf besonderes Interesse in Korbach. Schließlich ist
          die Familie der früheren ALS-Abiturientin bekannt in Waldeck. Und mit
          der Hirsch-Apotheke hatte die Mutter von drei erwachsenen Kindern das
          traditionsreichste Haus am Platze übernommen.
        </p>
        <p>
          Ein imposanter Fachwerkbau im Herzen der Korbacher Altstadt. Hier
          verbindet sich seine 280 Jahre währende Geschichte mit der modernen
          Medizin. Der springende Hirsch ist dabei ein besonderes
          Erkennungszeichen des Hauses.
        </p>
        <p>
          Die meiste Zeit des Jahres ruht die steinerne Figur auf einem Sockel
          an der Front des Gebäudes. Doch regelmäßig im Sommer wird das scheue
          Wild quasi zum Leben erweckt: Die aktuellen Abiturienten verkleiden
          ihn dann - humorvolle Gewänder mit einer Prise Zeitgeist sorgen für
          Aufsehen.
        </p>
        <p>
          Dann zeigt sich die enge Verbindung zwischen der Apotheke und der
          einst nur einen Steinwurf entfernten ALS. Das aus allen Nähten
          platzende frühere Lan-desgymnasium - vor über 400 Jahren gegründet -
          ist zwar Anfang der 1970er Jahre aus dem Altbau an der Klosterstraße
          an den Rand der Stadt umgezogen.
        </p>
        <p>
          Die Pennäler-Streiche sind aber fester Bestandteil der
          Abiturienten-Feiern geblieben: ein von den Korbachern mit großem
          Wohlwollen aufgenommenes, ständig wiederkehrendes Ereignis. Und ein
          beliebtes Fotomotiv.
        </p>
        <p>
          Zumal in der Apotheke einer der berühmtesten Söhne der Stadt, Prof.
          Hermann Kümmell, zur Welt gekommen ist. Der Chirurg und
          Hochschullehrer wurde durch die erste Blinddarm-Operation mit
          Bauch-schnitt berühmt. Seine Heimatstadt ernannte ihn zum Ehrenbürger.
          Das Geburtshaus gab auch der früheren &bdquo;Landstraße&ldquo; ihren
          Namen: Prof.-Kümmell-Straße.
        </p>
        <p>
          Kein Wunder, dass Pia Ueberson mit ein wenig Stolz das
          geschichtsträchtige Haus führt. Dabei hatte der Vater ganz andere
          Pläne. &bdquo;FIAT-Schmidt&ldquo; hätte gern gesehen, wenn sein
          Betrieb in der Familie geblieben wäre. Aber keines der Mädchen wollte
          die Werkstadt übernehmen.
        </p>
        <p>
          Auch die 1966 geborene Tochter wählte Biologie und Deutsch als
          ALS-Leistungskurse für das anschließende Pharmazie-Studium in Marburg.
          &bdquo;Apotheker sind heute gesuchte Fachleute in der
          Pharma-Industrie&ldquo;, wirbt Pia Ueberson für den Beruf. &bdquo;Sie
          übernehmen dort die gesamte Verantwortung für den
          Arzneimittelbetrieb.&ldquo; 80 Prozent der Studenten seien zwar
          weiblichen Geschlechts. Leider leiten aber überwiegend Männer die
          Apotheken, bemerkt sie.
        </p>
        <p>
          Die Korbacherin betont die gute Zusammenarbeit in ihrem Team. Sie lege
          großen Wert auf die freundliche Ansprache und kompetente Beratung
          ihrer Kunden.
        </p>
        <p>
          Eine wichtige Aufgabe komme ihrem Haus in der Kindermedizin zu. Die
          Arzneimittel für die jungen Patienten seien knapp. Hier helfe die
          Apotheke mit selbst hergestellten Rezepturen. Pia Ueberson: &bdquo;Man
          fühlt sich manchmal wie in einer Manufaktur, nur mit viel strengeren
          Auflagen.&ldquo; Es mache sie stolz, &bdquo;wenn wir diese Kinder
          später gesund in Korbach treffen.&ldquo;
        </p>
        <p>
          Dabei stellen moderne Techniken und Anforderungen des Gesetzgebers die
          Apotheken vor ständig wachsende Aufgaben. Jüngstes Beispiel: Die
          elektronische Gesundheitskarte und das E-Rezept. Die Apotheken fühlen
          sich manchmal geradezu überrollt. Von wegen alles ganz einfach:
          &bdquo;Sie müssen nur die Karte an ihr Handy halten&ldquo;, wie
          Günther Jauch in der Werbung sagt. &bdquo;Was ist aber zum Beispiel
          mit älteren Patienten, die kein Handy haben?&ldquo; fragt Pia
          Ueberson. Auch da muss vor Ort die Apotheke helfen.
        </p>
        <p>
          <i>
            GÜNTER GÖGE
            <br />
            Klosterglöckchen
          </i>
        </p>
      </article>
    </Layout>
  );
};
